import { uniq, map } from 'lodash';

export default (arrayOfObjects) => map(
  uniq(
    map(arrayOfObjects, (obj) => JSON.stringify(obj)),
  ), (obj) => JSON.parse(obj),
);
